// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  employee_id: yup.string().label("Employee").required(),
  transaction_date: yup.string().label("Date").required(),
  trx_code: yup.string().required(),
  location_id: yup.string().label("Location").required(),
  qty_build_unit: yup.number().label("Qty Build").min(1).required(),
  component_at_cost:yup.number().label("Component at Cost").required(),
  coa_overhead_id:yup.number().label("Account Overhead").required(),
  total_cac:yup.number().label("Total Component at Cost").required(),
  total_amount:yup.number().label("Total Amount").required(),
  overhead:yup.number().label("Overhead").required(),
})

export type FormType = yup.InferType<typeof validationSchema>